import { track } from 'scripts/modules/_tracking';
import { setUserCountryCode, setUserCountryName } from 'scripts/modules/_i18n';

export const initRSFooter = () => {
	const footerRegionSelect = document.querySelector( '.region-selection-footer--wrapper' );
	const footerRegionSelectModal = document.querySelector( '.region-selection-footer--modal' );

	if ( footerRegionSelect && footerRegionSelectModal ) {
		const closeModal = () => {
			footerRegionSelect.classList.remove( 'open' );
			document.body.classList.remove( 'overflow-hidden' );
		};

		footerRegionSelect.addEventListener( 'click', () => {
			if ( window.innerHeight - footerRegionSelect.getBoundingClientRect().y < 400 ) {
				footerRegionSelectModal.classList.add( 'top' );
				footerRegionSelectModal.classList.remove( 'bottom' );
			} else {
				footerRegionSelectModal.classList.add( 'bottom' );
				footerRegionSelectModal.classList.remove( 'top' );
			}

			footerRegionSelect.classList.toggle( 'open' );
			document.body.classList.toggle( 'overflow-hidden' );
		} );

		document.addEventListener( 'click', ( e ) => {
			if ( ! footerRegionSelect.contains( e.target ) ) {
				closeModal();
			}
		} );

		Array.from(
			footerRegionSelect.querySelectorAll( '.region-selection-footer--modal-item' )
		).forEach( ( item ) => {
			item.addEventListener( 'click', ( event ) => {
				event.preventDefault();
				event.stopPropagation();

				const countryCode = item.getAttribute( 'data-code' );
				const countryName = item.getAttribute( 'data-name' );

				setUserCountryCode( countryCode );
				setUserCountryName( countryName );
				track( 'gtm', {
					event: 'linkClick',
					ctaText: countryName.toLowerCase().replace( / /g, '' ),
					ctaSection: 'footer',
				} );

				window.location = item.href;
			} );
		} );
	}
};
